import React, {PropTypes} from 'react';
import {Modal} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

const DemoModal = ({
  isOpen,
  onClose,
  onStartDemo
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} id="modalSelectStore">
      { <div className="modal-header">
        <h4 className="modal-title" id="exampleModalLabel">{I18n.t('DEMO_TITLE')}</h4>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
          <span className="lnr lnr-cross" aria-hidden="true"/>
        </button>
      </div> }
      <div className="modal-body">
        <div className="row">
          <div className="col-sm-12">
            {I18n.t('DEMO_TEXT')}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={()=>onStartDemo('de')}>{I18n.t('DEMO_DE_LOGIN')}</button>
        { <button type="button" className="btn btn-primary" onClick={()=>onStartDemo('en')}>{I18n.t('DEMO_EN_LOGIN')}</button> }
      </div>
    </Modal>
  );
};

DemoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onStartDemo: PropTypes.func.isRequired,
};

export default DemoModal;


/** WEBPACK FOOTER **
 ** ./src/modules/customer/components/DemoModal.js
 **/